import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSignalsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetSignalsQuery = {
  __typename?: 'Query';
  signals: {
    __typename?: 'SignalConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'SignalEdge';
      cursor: string;
      node: {
        __typename?: 'Signal';
        id: any;
        name: string;
        description: string;
        signalType: Types.SignalType;
        createdAt: any;
        updatedAt: any;
        fingerprints: Array<
          | { __typename?: 'BlockFingerprint'; blockField: string }
          | { __typename?: 'LogFingerprint'; logField: Types.LogField }
          | {
              __typename?: 'TransactionFingerprint';
              transactionField: Types.TransactionField;
            }
        >;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasPreviousPage: boolean;
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export const GetSignalsDocument = gql`
  query GetSignals($after: String, $before: String, $first: Int, $last: Int) {
    signals(after: $after, before: $before, first: $first, last: $last) {
      totalCount
      edges {
        cursor
        node {
          id
          name
          description
          signalType
          createdAt
          updatedAt
          fingerprints {
            ... on BlockFingerprint {
              blockField: field
            }
            ... on TransactionFingerprint {
              transactionField: field
            }
            ... on LogFingerprint {
              logField: field
            }
          }
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetSignalsQuery__
 *
 * To run a query within a React component, call `useGetSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignalsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetSignalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSignalsQuery,
    GetSignalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSignalsQuery, GetSignalsQueryVariables>(
    GetSignalsDocument,
    options,
  );
}
export function useGetSignalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSignalsQuery,
    GetSignalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSignalsQuery, GetSignalsQueryVariables>(
    GetSignalsDocument,
    options,
  );
}
export function useGetSignalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSignalsQuery,
        GetSignalsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSignalsQuery, GetSignalsQueryVariables>(
    GetSignalsDocument,
    options,
  );
}
export type GetSignalsQueryHookResult = ReturnType<typeof useGetSignalsQuery>;
export type GetSignalsLazyQueryHookResult = ReturnType<
  typeof useGetSignalsLazyQuery
>;
export type GetSignalsSuspenseQueryHookResult = ReturnType<
  typeof useGetSignalsSuspenseQuery
>;
export type GetSignalsQueryResult = Apollo.QueryResult<
  GetSignalsQuery,
  GetSignalsQueryVariables
>;
